import { ChevronDown } from 'lucide-react';

import { useRazdely } from './razdely';

/**
 * ВЫБОР РАЗДЕЛА — НАД КАЛЕНДАРЁМ ЛЕВОЙ КОЛОНКИ (`s404`, Д-29, 13.09.2026).
 *
 * ⛔ ЭТО ТОТ ЖЕ ВЫБОР, ЧТО РИСОВАЛ САЙДБАР, А НЕ ВТОРОЙ. Значение и список
 * приходят из общего источника (`RazdelyContext`); заведи здесь своё состояние —
 * и шапка однажды покажет «Операционку», а меню под ней останется на «Финансах».
 *
 * ⛔ ЦВЕТА ОПЦИЙ — ЛИТЕРАЛОМ, не токеном (урок `s310`): токен внутри тёмной
 * шкуры разворачивается в белый, и текст пунктов пропадал на белом фоне
 * системного попапа.
 */
export function RazdelSelect() {
  const { gruppy, vybrannaya, vybrat } = useRazdely();

  return (
    <div className="relative w-full shrink-0">
      <select
        value={vybrannaya}
        aria-label="Раздел"
        onChange={(e) => vybrat(e.target.value)}
        className="ops-razdel-select w-full appearance-none rounded-ops-md py-2 pl-3.5 pr-9 text-ops-label font-bold tracking-wide text-white outline-none"
      >
        {gruppy.map((g) => (
          <option key={g} value={g} className="bg-white font-semibold text-[#1B2540]">
            {g}
          </option>
        ))}
      </select>
      <ChevronDown
        size={16}
        aria-hidden
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-white"
      />
    </div>
  );
}
